import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const NoMatch = () => {
  return (
    <h2>このページは存在しません。</h2>
  );
}
  
export default NoMatch;
